<!--
 * @Author: DY
 * @Date: 2024-12-14 12:34:15
 * @LastEditTime: 2025-04-18 15:21:34
 * @Description: 二次检测表单
 * @FilePath: \ShiMo_Mobile\src\views\purchase\secondaryTesting\form.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="secondaryTestingForm commonFormStyles">
            <van-nav-bar
                left-arrow
                left-text="列表"
                title="二次检测信息表"
                :style="`height: ${ $getNavHeight() }px;`"
                @click-left="swiperright"
            ></van-nav-bar>
            <div class="formList">
                <van-collapse v-model="activeCollapseItem">
                    <van-collapse-item title="基本信息" name="1">
                        <van-field
                            disabled
                            label="二次检测编号"
                            :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                            v-model="formData.QualityNumber"
                        ></van-field>
                        <van-field
                            disabled
                            label="需求签收单编号"
                            :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                            v-model="formData.AllocationNumber"
                        ></van-field>
                        <van-field
                            disabled
                            label="到场时间"
                            :left-icon="require('@/assets/images/icons/icon_36@2x.png')"
                            v-model="formData.IntoTime"
                        ></van-field>
                        <van-field
                            disabled
                            label="汽运单编号"
                            :left-icon="require('@/assets/images/icons/icon_11@2x.png')"
                            v-model="formData.YsdNumber"
                        ></van-field>
                        <van-field
                            readonly
                            label="物料代码"
                            :disabled="isDisabled"
                            :left-icon="require('@/assets/images/icons/icon_46@2x.png')"
                            v-model="formData.MaterialCode"
                            @click="showActionSheetFun"
                        ></van-field>
                        <van-field
                            disabled
                            label="短描述"
                            :left-icon="require('@/assets/images/icons/icon_28@2x.png')"
                            v-model="formData.MaterialShortName"
                        ></van-field>
                        <van-field
                            disabled
                            label="长描述"
                            :left-icon="require('@/assets/images/icons/icon_10@2x.png')"
                            v-model="formData.MaterialName"
                        ></van-field>
                        <van-field
                            disabled
                            label="单位"
                            :left-icon="require('@/assets/images/icons/icon_24@2x.png')"
                            v-model="formData.Unit"
                        ></van-field>
                        <van-field
                            disabled
                            label="到场数量"
                            :left-icon="require('@/assets/images/icons/icon_16@2x.png')"
                            v-model="formData.NetWeight"
                        ></van-field>
                        <van-field
                            disabled
                            label="一次签收数量"
                            :left-icon="require('@/assets/images/icons/icon_16@2x.png')"
                            v-model="formData.SignCount1"
                        ></van-field>
                        <van-field
                            disabled
                            label="外观检测意见"
                            :left-icon="require('@/assets/images/icons/icon_2@2x.png')"
                            v-model="formData.AppearanceDetection"
                            @click="showDepartment = true"
                        ></van-field>
                        <van-field
                            disabled
                            label="需求申请数量"
                            :left-icon="require('@/assets/images/icons/icon_16@2x.png')"
                            v-model="formData.ApplyCount"
                        ></van-field>
                        <van-field
                            disabled
                            label="供应分配数量"
                            :left-icon="require('@/assets/images/icons/icon_16@2x.png')"
                            v-model="formData.SupplyCount"
                        ></van-field>
                        <van-field
                            disabled
                            label="需求部门"
                            :left-icon="require('@/assets/images/icons/icon_29@2x.png')"
                            v-model="formData.ApplyDeptName"
                        ></van-field>
                        <van-field
                            disabled
                            label="需求部门联系人"
                            :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                            v-model="formData.ApplyUserName"
                        ></van-field>
                        <van-field
                            disabled
                            label="核对人"
                            :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                            v-model="formData.CheckUserName1"
                        ></van-field>
                        <van-field
                            disabled
                            label="	核对时间"
                            :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                            v-model="formData.CheckTime1"
                        ></van-field>
                        <van-field
                            label="备注"
                            type="textarea"
                            :rows="2"
                            :disabled="isDisabled || Status != 0"
                            :left-icon="require('@/assets/images/icons/icon_10@2x.png')"
                            v-model="formData.Remarks"
                        ></van-field>
                    </van-collapse-item>
                    <van-collapse-item name="2" v-if="Status > 0">
                        <template #title>
                            <span>质检二次检测意见</span>
                        </template>
                        <van-field
                            disabled
                            label="检测人"
                            placeholder="自动生成"
                            :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                            v-model="formData.CheckUserName2"
                        ></van-field>
                        <van-field
                            disabled
                            label="检测时间"
                            :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                            v-model="formData.CheckTime2"
                        ></van-field>
                        <van-field
                            label="检测意见"
                            type="textarea"
                            :rows="2"
                            :disabled="isDisabled || Status != 1"
                            :left-icon="require('@/assets/images/icons/icon_10@2x.png')"
                            v-model="formData.CheckOpinion2"
                        ></van-field>
                    </van-collapse-item>
                    <van-collapse-item name="3" v-if="Status > 1">
                        <template #title>
                            <span>需求部门意见</span>
                        </template>
                        <van-field
                            disabled
                            label="需求部门联系人"
                            placeholder="自动生成"
                            :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                            v-model="formData.ApplyUserName2"
                        ></van-field>
                        <van-field
                            disabled
                            label="反馈时间"
                            :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                            v-model="formData.ApplyFeedbackTime2"
                        ></van-field>
                        <van-field
                            label="需求部门意见"
                            type="textarea"
                            :rows="2"
                            :disabled="isDisabled || Status != 2"
                            :left-icon="require('@/assets/images/icons/icon_10@2x.png')"
                            v-model="formData.ApplyOpinion2"
                        ></van-field>
                    </van-collapse-item>
                    <van-collapse-item name="4" v-if="Status > 2">
                        <template #title>
                            <span>采购部门意见</span>
                        </template>
                        <van-field
                            disabled
                            label="合同单价（元）"
                            placeholder="自动生成"
                            :left-icon="require('@/assets/images/icons/icon_20@2x.png')"
                            v-model="formData.UnitPrice"
                        ></van-field>
                        <van-field
                            disabled
                            label="本次物料金额（元）"
                            placeholder="自动生成"
                            :left-icon="require('@/assets/images/icons/icon_22@2x.png')"
                            v-model="formData.Money"
                        ></van-field>
                        <van-field
                            label="扣罚类别"
                            name="radio"
                            class="fieldRadio"
                            :left-icon="require('@/assets/images/icons/icon_13@2x.png')"
                        >
                            <template #input>
                                <van-radio-group v-model="formData.Result2" direction="horizontal" :disabled="isDisabled || Status != 3">
                                    <van-radio :name="1" checked-color="#ee0a24">
                                        全部接收
                                    </van-radio>
                                    <van-radio :name="2" checked-color="#ee0a24">
                                        让步接收
                                    </van-radio>
                                    <van-radio :name="3" checked-color="#ee0a24">
                                        退货
                                    </van-radio>
                                </van-radio-group>
                            </template>
                        </van-field>
                        <van-field
                            label="二次签收数量"
                            placeholder="自动生成"
                            :disabled="isDisabled || Status != 3"
                            :left-icon="require('@/assets/images/icons/icon_16@2x.png')"
                            v-model="formData.SignCount2"
                            @change="signedAmountSignedAmount"
                        ></van-field>
                        <van-field
                            disabled
                            label="签收物料金额"
                            placeholder="自动生成"
                            :left-icon="require('@/assets/images/icons/icon_22@2x.png')"
                            v-model="formData.SignMoney2"
                        ></van-field>
                        <van-field
                            disabled
                            :readonly="Status == 3"
                            label="采购部门人员"
                            placeholder="自动生成"
                            :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                            v-model="formData.ProcurementDeptUserName"
                        ></van-field>
                        <template v-if="Status > 3">
                            <van-field
                                disabled
                                :readonly="Status == 4"
                                label="采购主管领导签字"
                                placeholder="自动生成"
                                :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                                v-model="formData.ProcurementDeptOpinion"
                            ></van-field>
                        </template>
                    </van-collapse-item>
                </van-collapse>
                <van-action-sheet
                    v-model="showActionSheet"
                    cancel-text="取消"
                    description="选择物料"
                    :actions="columns"
                    :style="{height: '30%'}"
                    @select="selectConfirm"
                ></van-action-sheet>
            </div>
            <footer class="currencyFooterStyle">
                <template v-if="!isDisabled">
                    <button class="confirm" @click="submitForm">
                        提交
                    </button>
                    <button class="confirm" @click="saveForm">
                        保存
                    </button>
                </template>
                <button class="confirm" @click="closeAllocationForm">
                    关闭
                </button>
            </footer>
        </div>
    </v-touch>
</template>

<script>
import currencyFun from '@/assets/js/currencyFun/index.js';
import NP from 'number-precision';
NP.enableBoundaryChecking(false);
export default {
    // 库位表单
    name: 'secondary-testing-form',
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (['demandSignForReceiptForm', 'secondaryTesting'].includes(from.name)) {
                vm.backPathName = from.name;
            }
        });
    },
    beforeRouteLeave(to, from, next) {
        if (to.name === this.backPathName) {
            this.$store.commit('noKeepAlive', 'secondary-testing-form');
        }
        next();
    },
    components: {},
    props: {},
    data() {
        return {
            showActionSheet: false,
            columns: [],
            backPathName: '',
            isDisabled: false,
            activeCollapseItem: ['1', '2', '3', '4'],
            formData: {
                Id: '',
                QualityNumber: '',
                AllocationNumber: '',
                IntoTime: '',
                YsdNumber: '',
                YsdmId: '',
                YsdmaId: '',
                Category: 0,
                MaterialCode: '',
                MaterialName: '',
                MaterialShortName: '',
                MaterialType: '',
                NetWeight: 0,
                SignCount1: 0,
                AppearanceDetection: '',
                ApplyDeptId: '',
                ApplyDeptName: '',
                ApplyUserId: '',
                ApplyUserName: '',
                CheckUserId1: '',
                CheckUserName1: '',
                CheckTime1: '',
                CheckUserId2: '',
                CheckUserName2: '',
                CheckTime2: '',
                CheckOpinion2: '',
                ApplyUserId2: '',
                ApplyUserName2: '',
                ApplyFeedbackTime2: '',
                ApplyOpinion2: '',
                UnitPrice: 0,
                Money: 0,
                Result2: 0,
                SignCount2: 0,
                SignMoney2: 0,
                ProcurementDeptUserId: '',
                ProcurementDeptUserName: '',
                ProcurementDeptOpinion: '',
                Remarks: '',
            },
            pageData: {},
            Status: 0,
        };
    },
    computed: {},
    watch: {},
    activated() {},
    created() {
        this.initpage();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({
                name: this.backPathName,
            });
        },

        async initpage() {
            if (this.$route.params.type === 'see') {
                this.isDisabled = true;
            }
            if (this.$route.params.type === 'edit' || this.$route.params.type === 'see') {
                this.formData = await this.getSecondSignatureInfo(this.$route.params.data.id);
                this.Status = this.formData.Status;
            } else if (this.$route.params.type === 'demandSignForReceiptForm') {
                this.pageData = await this.getSecondSignatureInit(this.$route.params.data.Id);
                this.formData.IntoTime = this.pageData.Ysd.IntoTime;
                this.formData.YsdNumber = this.pageData.Ysd.YsdNumber;
                this.formData.ApplyDeptName = this.pageData.YsdAllocation.ApplyDeptName;
                this.formData.ApplyDeptId = this.pageData.YsdAllocation.ApplyDeptId;
                this.formData.AllocationNumber = this.pageData.YsdAllocation.AllocationNumber;
                this.formData.ApplyUserName = this.$takeTokenParameters('Name');
                this.formData.ApplyUserId = this.$takeTokenParameters('Uid');
                this.formData.CheckUserName1 = this.pageData.Ysd.CheckUserName1;
                this.formData.CheckUserId1 = this.pageData.Ysd.CheckUserId1;
                this.formData.CheckTime1 = this.pageData.Ysd.CheckTime1;
                if ((this.pageData.MaterialAllocationList || []).length > 0) {
                    this.materialCodeAssignment(0);
                } else {
                    this.$toast('没有可发起检测的物料');
                }
                this.Status = 0;
            }
            if (this.Status === 1) {
                this.formData.CheckUserName2 = this.$takeTokenParameters('Name');
                this.formData.CheckUserId2 = this.$takeTokenParameters('Uid');
                this.formData.CheckTime2 = currencyFun.timeFormat(new Date(), 'yyyy-MM-dd HH:mm:ss');
            } else if (this.Status === 2) {
                this.formData.ApplyUserName2 = this.$takeTokenParameters('Name');
                this.formData.ApplyUserId2 = this.$takeTokenParameters('Uid');
                this.formData.ApplyFeedbackTime2 = currencyFun.timeFormat(new Date(), 'yyyy-MM-dd HH:mm:ss');
            } else if (this.Status === 3) {
                this.formData.ProcurementDeptUserName = this.$takeTokenParameters('Name');
                this.formData.ProcurementDeptUserId = this.$takeTokenParameters('Uid');
            } else if (this.Status === 4) {
                this.formData.ProcurementDeptOpinion = this.$takeTokenParameters('Name');
            }
            this.calculationMaterialAmount();
        },

        showActionSheetFun() {
            this.columns = (this.pageData.MaterialAllocationList || []).map(item => {
                return {
                    name: item.MaterialCode,
                };
            });
            this.showActionSheet = true;
        },

        selectConfirm(data) {
            const index = this.pageData.MaterialAllocationList.findIndex(item => item.MaterialCode === data.name);
            this.materialCodeAssignment(index);
            this.showActionSheet = false;
        },

        materialCodeAssignment(index) {
            this.formData.MaterialCode = this.pageData.MaterialAllocationList[index].MaterialCode;
            this.formData.MaterialName = this.pageData.MaterialAllocationList[index].MaterialName;
            this.formData.MaterialType = this.pageData.MaterialAllocationList[index].MaterialType;
            this.formData.MaterialShortName = this.pageData.MaterialAllocationList[index].MaterialShortName;
            this.formData.NetWeight = this.pageData.MaterialAllocationList[index].NetWeight;
            this.formData.SignCount1 = this.pageData.MaterialAllocationList[index].SignCount;
            this.formData.AppearanceDetection = this.pageData.MaterialAllocationList[index].AppearanceDetection;
            this.formData.YsdmId = this.pageData.MaterialAllocationList[index].YsdmId;
            this.formData.UnitPrice = this.pageData.MaterialAllocationList[index].UnitPrice;
            this.formData.ApplyCount = this.pageData.MaterialAllocationList[index].ApplyCount;
            this.formData.SupplyCount = this.pageData.MaterialAllocationList[index].SupplyCount;
            this.formData.Unit = this.pageData.MaterialAllocationList[index].Unit;
        },

        calculationMaterialAmount() {
            this.formData.Money = NP.times(this.formData.SignCount1 || 0, this.formData.UnitPrice || 0);
        },

        signedAmountSignedAmount() {
            this.formData.SignMoney2 = NP.times(this.formData.SignCount2 || 0, this.formData.UnitPrice || 0);
        },

        async saveForm() {
            const res = await this.saveSecondSignature(this.formData);
            if (res) {
                this.$toast.success('保存成功。');
            }
        },

        async submitForm() {
            const saveRes = await this.saveSecondSignature(this.formData);
            if (saveRes) {
                this.formData = saveRes;
                this.Status = saveRes.Status;
                const res = await this.submitSecondSignature(saveRes.Id, this.Status);
                if (res) {
                    this.$toast.success('提交成功。');
                    this.closeAllocationForm();
                }
            }
        },

        closeAllocationForm() {
            this.$router.isBack = 1;
            this.$router.replace({
                name: this.backPathName,
                params: {
                    saveCallback: true,
                },
            });
        },

        // 获取二次签收初始化信息
        getSecondSignatureInit(id) {
            return this.$axios.$get(`/interfaceApi/procurement/ysd_material_quality/init/${id}`, { defEx: true });
        },
        // 获取二次签收基本信息
        getSecondSignatureInfo(id) {
            return this.$axios.$get(`/interfaceApi/procurement/ysd_material_quality/info/${id}`, { defEx: true });
        },
        // 保存二次签收信息
        saveSecondSignature(requestData) {
            return this.$axios.$post('/interfaceApi/procurement/ysd_material_quality/create', requestData, { defEx: true });
        },
        // 提交二次签收信息
        submitSecondSignature(id, now_status) {
            return this.$axios.$get(`/interfaceApi/procurement/ysd_material_quality/submit/${id}/${now_status}`, { defEx: true });
        },
    },
};
</script>
<style lang="stylus"></style>